module.exports = __webpack_public_path__ + "static/media/android.b4a5d2c2.png";